<ng-container *ngFor="let partial of routedLabel">
  <span *ngIf="!partial.route" [innerHTML]="partial.text"></span>
  <a
    luiLink
    *ngIf="partial.route"
    [routerLink]="partial.route"
    [fragment]="partial.fragment || ''"
    [innerHTML]="partial.text"
  ></a>
</ng-container>
